import {
	axiosGet,
	axiosLogs,
	axiosPost,
	axiosPostBlob,
	axiosPut,
} from "../../main/app-axios";
import consts from "../../main/consts";
import { STATUS } from "../../main/status";
import { salesChannelIsAmericanas } from "../../utils/check-sales-channel";
import { showMessage } from "../app/appActions";
import { types } from "./types";

export const getRowsAndTotal =
	async ({
		page = 0,
		limit = consts.GRID_QTD,
		filters = {},
		pageId,
		avoidSpinner,
		inferTotal = false,
	}) =>
	(dispatch) => {
		if (!avoidSpinner) {
			dispatch({
				type: types.GET_ORDERS,
				payload: {
					loaded: false,
					order: {},
				},
			});
		}
		const skip = 0;
		const paramsOrderByDefault = (filters) => {
			let isSorting = false;

			[
				"ordemNumero",
				"ordemDataInclusao",
				"ordemNomeCliente",
				"ordemNomeAssociado",
				"ordemOrigem",
				"ordemEntrega",
				"ordemStatus",
				"ordemValorTotal",
				"ordemTipoEntrega",
				"ordemCodigoExterno",
			].map((order) => {
				if (filters[order] !== undefined) isSorting = true;
				return order;
			});

			if (!isSorting) {
				filters["ordemDataInclusao"] = "desc";
			}
		};
		paramsOrderByDefault(filters);
		return axiosGet(
			`/pedido/skip/${skip}/limit/${limit}`,
			filters,
			dispatch,
		).then((response) => {
			if (response && response.status === 200) {
				const records = response.data.data.records;
				const count = response.data.data.count;
				// O back tem um bug conhecido (não priorizado, por performance) em que o
				// count vem 0 mesmo havendo registros, o que trava o scroll infinito.
				// Com inferTotal, deduz se ainda há mais pela página ter vindo cheia.
				// Só as telas que optam por isso pagam o preço (1 request extra quando o
				// total é múltiplo exato do limit); as demais seguem com o count puro.
				const total =
					count > 0 || !inferTotal
						? count
						: records.length === Number(limit)
							? records.length + 1
							: records.length;

				dispatch({
					type: types.GET_ORDERS,
					payload: {
						grids: {
							[pageId]: {
								rows: records,
								total,
								counts: response.data.data.counts,
								store: response.data.data.store,
								selectedFilter:
									filters.origem !== "" ? filters.origem : undefined,
							},
						},
						status: filters.status,
						page: 0,
						loaded: true,
						order: {},
					},
				});
			}
		});
	};

export const getNovosPedidosPendentes =
	({ limit = 20 } = {}) =>
	async (dispatch) => {
		const response = await axiosGet(
			`/pedido/skip/0/limit/${limit}`,
			{
				minDias: 0,
				status: STATUS.NOVO_PEDIDO,
				ordemDataInclusao: "asc",
			},
			dispatch,
		);

		if (!response || response.status !== 200) {
			return [];
		}

		return response.data.data.records || [];
	};

export const confirmarColetaTardia =
	async (origem, codigoExterno) => (dispatch) => {
		return axiosPut(
			`/api/pedidos/${origem}/${codigoExterno}/confirmarColetaTardia`,
			{},
			dispatch,
		);
	};

export const naoColetado = async (origem, codigoExterno) => (dispatch) => {
	return axiosPut(
		`/api/pedidos/${origem}/${codigoExterno}/naoColetado`,
		{},
		dispatch,
	);
};

export const atualizarEstoque = (numero) => async (dispatch) => {
	await axiosPut(`/pedido/${numero}/update-inventory`, {}, dispatch);
};

export const getOrderByNumero = (numero, avoidSpinner) => async (dispatch) => {
	if (!avoidSpinner) {
		dispatch({
			type: types.GET_ORDERS,
			payload: {
				loaded: false,
				order: {},
			},
		});
	}

	const response = await axiosGet(`/pedido/${numero}`, {}, dispatch);
	if (response && response.status === 200) {
		dispatch({
			type: types.GET_ORDER,
			payload: response.data.data,
		});
	}
};

export const addNewOrder =
	async ({ newOrder }) =>
	(dispatch) => {
		return dispatch({
			type: types.ADD_ORDERS,
			payload: newOrder,
		});
	};

export const updateOrderStatus =
	async ({
		numero,
		status,
		origem,
		codigoExterno,
		canalDeVendas,
		loja,
		...params
	}) =>
	(dispatch) => {
		let paramsQuery = "";
		let nextStatus = "";

		const isAmericanasSalesChannel = salesChannelIsAmericanas(canalDeVendas);

		if (
			status === "PRONTO_PARA_SAIR" ||
			status === "EDITADO" ||
			status === "CANCELADO"
		) {
			paramsQuery += "?";
			for (const key in params) {
				if (Object.hasOwn(params, key)) {
					paramsQuery += `${key}=${params[key]}&`;
				}
			}
			paramsQuery = paramsQuery.slice(0, -1);
		}

		if (origem === "PEGUE_NA_LOJA" && status === "SAIU_PARA_ENTREGA") {
			nextStatus = "FINALIZADO";
		} else nextStatus = status;

		switch (nextStatus) {
			case STATUS.EM_SEPARACAO:
				return axiosPut(
					`/api/pedidos/${origem}/${codigoExterno}/emSeparacao${paramsQuery}`,
					params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			case STATUS.PRONTO_PARA_SAIR:
				return axiosPut(
					`/api/pedidos/${origem}/${codigoExterno}/prontoParaSair${paramsQuery}`,
					{ ...params, numero },
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			case STATUS.EDITADO:
				return axiosPut(
					`/api/pedidos/${origem}/${codigoExterno}/prontoParaSair${paramsQuery}`,
					params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			case STATUS.SAIU_PARA_ENTREGA:
				return axiosPut(
					`/api/pedidos/${origem}/${codigoExterno}/saiuParaEntrega${paramsQuery}`,
					params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			case STATUS.FINALIZADO:
				return axiosPut(
					`/api/pedidos/${origem}/${codigoExterno}/finalizado${paramsQuery}`,
					{ ...params, numero },
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			case STATUS.CANCELADO: {
				const urlToCancel = mountUpdateOrderStatusCancelUrl(
					origem,
					codigoExterno,
					loja,
					params,
					isAmericanasSalesChannel,
				);
				const methodCancel =
					isAmericanasSalesChannel || params.motivo ? axiosPut : axiosPost;
				return methodCancel(
					`${urlToCancel}${paramsQuery}`,
					origem === "PEGUE_NA_LOJA"
						? {
								params,
								numero,
								motivo: "38",
							}
						: params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			}
			case STATUS.RETORNAR_PARA_ESTOQUE: {
				const returnToStockUrl = mountUpdateOrderStatusReturnToStockUrl(
					origem,
					codigoExterno,
					loja,
					paramsQuery,
					isAmericanasSalesChannel,
				);
				const methodReturnToStock = isAmericanasSalesChannel
					? axiosPut
					: axiosPost;
				return methodReturnToStock(returnToStockUrl, params, dispatch).then(
					(response) => {
						return dispatch({
							type: types.UPDATE_ORDER,
							payload: response,
						});
					},
				);
			}
			case STATUS.DEVOLVIDO: {
				const urlToDevolution = mountUpdateOrderStatusDevolutionUrl(
					origem,
					codigoExterno,
					loja,
					isAmericanasSalesChannel,
				);
				const methodDevolution = isAmericanasSalesChannel
					? axiosPut
					: axiosPost;
				return methodDevolution(
					`${urlToDevolution}${paramsQuery}`,
					params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
			}
			default:
				return axiosPut(
					`/pedido/${numero}/status/${status}${paramsQuery}`,
					params,
					dispatch,
				).then((response) => {
					return dispatch({
						type: types.UPDATE_ORDER,
						payload: response,
					});
				});
		}
	};

const mountUpdateOrderStatusCancelUrl = (
	origem,
	codigoExterno,
	loja,
	params,
	isAmericanasSalesChannel,
) => {
	const codigo =
		origem === "PEGUE_NA_LOJA" ? codigoExterno.split("#")[0] : codigoExterno;
	const status = origem === "PEGUE_NA_LOJA" ? "retornarEstoque" : "cancelado";

	if (isAmericanasSalesChannel || params.motivo) {
		return `/api/pedidos/${origem}/${codigo}/${status}`;
	}

	return `/api/pedidos/${loja}/${codigo}/cancel`;
};

const mountUpdateOrderStatusDevolutionUrl = (
	origem,
	codigoExterno,
	loja,
	isAmericanasSalesChannel,
) => {
	if (isAmericanasSalesChannel) {
		return `/api/pedidos/${origem}/${codigoExterno}/devolvido`;
	}

	return `/api/pedidos/${loja}/${codigoExterno}/devolution`;
};

const mountUpdateOrderStatusReturnToStockUrl = (
	origem,
	codigoExterno,
	loja,
	paramsQuery,
	isAmericanasSalesChannel,
) => {
	const codigo =
		origem === "PEGUE_NA_LOJA" ? codigoExterno.split("#")[0] : codigoExterno;

	if (isAmericanasSalesChannel) {
		return `/api/pedidos/${origem}/${codigoExterno}/retornarParaEstoque${paramsQuery}`;
	}

	return `/api/pedidos/${loja}/${codigo}/cancel`;
};

export const getAllCounts = async (args) => (dispatch) => {
	const userInfo = JSON.parse(localStorage.getItem("userInfo"));

	if (userInfo && userInfo.token) {
		const query =
			(args && args.status) ||
			"PREVISTO,NOVO_PEDIDO,EDITADO,EM_EDICAO,EM_SEPARACAO,PRONTO_PARA_SAIR,SAIU_PARA_ENTREGA,RETORNAR_PARA_ESTOQUE,PREVISTO";

		return axiosGet(`/pedido/count?status=${query}`, {}, dispatch).then(
			(response) => {
				if (response && response.status === 200) {
					return dispatch({
						type: types.GET_COUNTS,
						payload: {
							totals: response.data.data,
						},
					});
				}
			},
		);
	}
};

export const getDashboard = async (dataInicial, dataFinal) => (dispatch) => {
	const query =
		"PREVISTO,NOVO_PEDIDO,EM_SEPARACAO,EDITADO,PRONTO_PARA_SAIR,SAIU_PARA_ENTREGA,RETORNAR_PARA_ESTOQUE,FINALIZADO,CANCELADO,DEVOLVIDO";

	return axiosGet(
		`/pedido/dashboard?status=${query}&dataInicial=${dataInicial
			.toDate()
			.toISOString()}&dataFinal=${dataFinal.toDate().toISOString()}`,
		{},
		dispatch,
	).then((response) => {
		if (response && response.status === 200) {
			return dispatch({
				type: types.GET_DASHBOARD,
				payload: response.data.data,
			});
		}
	});
};

export const getReasonsForCancellation = async (args) => (dispatch) => {
	return axiosGet(`/pedido/motivo/recusa`, args, dispatch).then((response) => {
		if (response && response.status === 200) {
			dispatch({
				type: types.GET_REASONS,
				payload: {
					reasons: response.data.data,
				},
			});
		}
	});
};

export const getMotivosInsucesso = async (args) => (dispatch) => {
	return axiosGet(`/pedido/motivo/insucesso`, args, dispatch).then(
		(response) => {
			if (response && response.status === 200) {
				dispatch({
					type: types.GET_MOTIVOS_INSUCESSO,
					payload: response.data.data,
				});
			}
		},
	);
};

export const getMotivosRecusa = async (args) => (dispatch) => {
	return axiosGet(`/pedido/motivo/recusaLojaClick`, args, dispatch).then(
		(response) => {
			if (response && response.status === 200) {
				dispatch({
					type: types.GET_MOTIVOS_RECUSA,
					payload: response.data.data,
				});
			}
		},
	);
};

export const getMotivosCancelarRecebimento = async (args) => (dispatch) => {
	return axiosGet(`/pedido/motivo/recusaClienteClick`, args, dispatch).then(
		(response) => {
			if (response && response.status === 200) {
				dispatch({
					type: types.GET_MOTIVOS_CANCELAR_RETIRADA,
					payload: response.data.data,
				});
			}
		},
	);
};

export const handshakeRappiValidate =
	async (code, codigoExterno, callback) => (dispatch) => {
		return axiosPost(
			"/rappi/handshake/validate",
			{ code, codigoExterno },
			dispatch,
		).then((response) => {
			if (response && response.status === 200) {
				callback(response.data.data);
			} else if (response && response.status === 409) {
				callback(response.data);
			} else {
				callback(null);
			}
		});
	};

export const getOrderCodigoStatus =
	async (codigo, numero, cb) => (dispatch) => {
		return axiosGet(
			`/pedido/codigo/${codigo}?numero=${numero}`,
			{},
			dispatch,
		).then((response) => {
			if (response && response.data) {
				cb(response.data.data || response.data);
			} else {
				cb(null);
			}
		});
	};

export const callMotoboy = async (numero) => (dispatch) => {
	return axiosPut("/integrationEventFlow/chamarMotoboy", { numero }, dispatch);
};

export const retryOrder = async (origem, codigoExterno) => (dispatch) => {
	return axiosPut(
		`/api/pedidos/${origem}/${codigoExterno}/retentativa`,
		{},
		dispatch,
	).then((res) => {
		if (res && res.status === 200) {
			dispatch(showMessage("Tentando novamente...", "success"));
		} else {
			dispatch(showMessage("Ocorreu algum erro", "error"));
		}
	});
};

export const putRecusarPedidoPrevisto =
	async (
		origem,
		codigoExterno,
		motivo,
		observacao,
		nomeAutorizador,
		emailAutorizador,
	) =>
	(dispatch) => {
		return axiosPut(
			`/api/pedidos/${origem}/${codigoExterno}/cancelado`,
			{
				motivo: motivo,
				editado: null,
				recusado: true,
				retry: false,
				observacao,
				nomeAutorizador,
				emailAutorizador,
			},
			dispatch,
		).then((res) => {
			if (res && res.status === 200) {
				dispatch(showMessage("Ação realizada com sucesso", "success"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: true,
				});
			} else {
				dispatch(showMessage("Ocorreu algum erro", "error"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: false,
				});
			}
		});
	};

export const putCancelarRecebimentoProntoParaRetirada =
	async (
		origem,
		codigoExterno,
		motivo,
		observacao,
		nomeAutorizador,
		emailAutorizador,
	) =>
	(dispatch) => {
		return axiosPut(
			`/api/pedidos/${origem}/${codigoExterno}/retornarEstoque`,
			{
				motivo: motivo,
				editado: null,
				recusado: true,
				retry: false,
				observacao,
				nomeAutorizador,
				emailAutorizador,
			},
			dispatch,
		).then((res) => {
			if (res && res.status === 200) {
				dispatch(showMessage("Ação realizada com sucesso", "success"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: true,
				});
			} else {
				dispatch(showMessage("Ocorreu algum erro", "error"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: false,
				});
			}
		});
	};

export const putDevolvolverTransportadora =
	async (origem, codigoExterno, data) => (dispatch) => {
		const {
			nomeTransportadora,
			nomeColetor,
			cpfColetor,
			nomeAutorizador,
			emailAutorizador,
		} = data;
		const currentDateTime = new Date();

		return axiosPut(
			`/api/pedidos/${origem}/${codigoExterno}/cancelado`,
			{
				retornoTransportadora: {
					nomeTransportadora,
					nomeColetor,
					cpfColetor,
					dataRetirada: currentDateTime.toISOString(),
				},
				nomeAutorizador,
				emailAutorizador,
			},
			dispatch,
		).then((res) => {
			if (res && res.status === 200) {
				dispatch(showMessage("Ação realizada com sucesso", "success"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: true,
				});
			} else {
				dispatch(showMessage("Ocorreu algum erro", "error"));
				dispatch({
					type: types.SET_MODAL_CLOSED,
					payload: false,
				});
			}
		});
	};

export const getLogs = async (codigoExterno, origem) => (dispatch) => {
	axiosLogs({
		method: "get",
		url: `/logs?codigoExterno=${encodeURIComponent(
			codigoExterno,
		)}&origem=${origem}`,
		crossDomain: true,
	})
		.then((res) => {
			if (res && res.status === 200) {
				dispatch({
					type: types.GET_ORDER_LOGS,
					payload: {
						loaded: true,
						logs: res.data.data,
					},
				});
			}
		})
		.catch(console.log);
};

export const debugPago = async (codigoExterno, action) => (dispatch) => {
	axiosPost("/pedido/debug/pago", { codigoExterno }, dispatch).then((res) => {
		if (res && res.status === 200) {
			dispatch(
				showMessage("Simulação em processamento", "success", {
					action: action(res.data.data.numero),
				}),
			);
		} else {
			dispatch(showMessage("Ocorreu algum erro na simulação", "error"));
		}
	});
};

export const debugEditado = async (codigoExterno, action) => (dispatch) => {
	axiosPost("/pedido/debug/editado", { codigoExterno }, dispatch).then(
		(res) => {
			if (res && res.status === 200) {
				console.log(res);
				dispatch(
					showMessage("Simulação em processamento", "success", {
						action: action(res.data.data.numero),
					}),
				);
			} else {
				dispatch(showMessage("Ocorreu algum erro na simulação", "error"));
			}
		},
	);
};

export const debugEntregue = async (codigoExterno, action) => (dispatch) => {
	axiosPost("/pedido/debug/entregue", { codigoExterno }, dispatch).then(
		(res) => {
			if (res && res.status === 200) {
				dispatch(
					showMessage("Simulação em processamento", "success", {
						action: action(res.data.data.numero),
					}),
				);
			} else {
				dispatch(showMessage("Ocorreu algum erro na simulação", "error"));
			}
		},
	);
};

export const debugCancelado = async (codigoExterno, action) => (dispatch) => {
	axiosPost("/pedido/debug/cancelado", { codigoExterno }, dispatch).then(
		(res) => {
			if (res && res.status === 200) {
				dispatch(
					showMessage("Simulação em processamento", "success", {
						action: action(res.data.data.numero),
					}),
				);
			} else {
				dispatch(showMessage("Ocorreu algum erro na simulação", "error"));
			}
		},
	);
};

export const debugCreate = async (json) => (dispatch) => {
	axiosPost("/pedido/debug/create", { ...json }, dispatch).then((res) => {
		if (res && res.status === 200) {
			dispatch(showMessage("Pedido sendo processado", "success"));
		} else {
			dispatch(showMessage("Ocorreu algum erro na criação do pedido", "error"));
		}
	});
};

export const sendError = async (stack) => (dispatch) => {
	axiosPost("/pedido/reportarErro", { stack }, dispatch);
};

export const setFilter = (filter, value) => (dispatch) => {
	dispatch({ type: types.SET_FILTER, payload: { [filter]: value } });
};

export const setPegueFilter = (validate) => (dispatch) => {
	dispatch({ type: types.SET_LIMIT, payload: validate });
};

export const setReRender = (validate) => (dispatch) => {
	dispatch({ type: types.SET_RENDER, payload: validate });
};

export const verifyDevolution = () => async (dispatch) => {
	const response = await axiosGet("/api/pedidos/loja/devolucao");
	try {
		dispatch({
			type: types.SET_DEVOLUTION,
			payload: response.data.data.devolucao,
		});
		return response.data.data.devolucao;
	} catch (err) {}
};

export const handshakeRappi = (codigoExterno) => async (dispatch) => {
	return await axiosPost("/rappi/handshake", { codigoExterno }, dispatch);
};

export const handleImprimirEtiqueta = (numero) => async (dispatch) => {
	const res = await axiosPostBlob(`/pedido/${numero}/etiqueta`, {}, dispatch);
	if (res?.status !== 200) {
		let message = null;
		if (res?.data instanceof Blob) {
			try {
				let text = "";
				if (typeof res.data.text === "function") {
					text = await res.data.text();
				} else {
					text = await new Promise((resolve, reject) => {
						const reader = new FileReader();
						reader.onload = () => resolve(reader.result);
						reader.onerror = () => reject(reader.error);
						reader.readAsText(res.data);
					});
				}
				const parsed = JSON.parse(text);
				message = parsed?.message || parsed?.error || null;
			} catch (err) {
				console.error("Error parsing blob error response:", err);
			}
		} else if (res?.data?.message) {
			message = res.data.message;
		} else if (res?.message) {
			message = res.message;
		}
		return { status: 'SHOULD_OPEN_MODAL', message: message || null };
	}

	return res;
};

export const handleUpdateEventImprimirNotaFiscal =
	(numero, notaFiscalChave) => (dispatch) => {
		return axiosPut(
			`/pedido/${numero}/event/IMPRIMIR_NOTA_FISCAL/done`,
			{},
			dispatch,
		).then((res) => {
			if (res && res.status === 200) {
				dispatch({ type: types.UPDATE_EVENT_IMPRIMIR_NOTA_FISCAL });
				return res;
			} else {
				dispatch(
					showMessage(
						"Ocorreu algum erro ao atualizar o evento de impressão da nota fiscal",
						"error",
					),
				);
			}
		});
	};

export const handleImprimirNota = (numero) => (dispatch) => {
	return axiosPostBlob(`/pedido/${numero}/nota-fiscal`, {}, dispatch).then(
		(res) => {
			if (res && res.status === 200) {
				return res;
			} else {
				dispatch(
					showMessage("Ocorreu algum erro ao baixar a nota fiscal", "error"),
				);
			}
		},
	);
};
